export const StatesTabs = ({ tabs, setActiveState }: { tabs: any[], setActiveState: any }) => {

    const onClickTab = (id: string) => {
        const newTabs = [...tabs]
        newTabs.forEach(t => {
            t.active = t.id === id
        })
        setActiveState(newTabs)
    }


    return (
        <div className='tabs_state'>
            {tabs.map((t, i) => (
                <div className={`tab ${t.active && "active"}`} key={i} onClick={() => onClickTab(t.id)}>
                    <div>{t.name}</div>
                    {t.amountElement ? (<div className={`numberItems ${t.active && "active"}`} >{t.amountElement}</div>) : null}
                </div>
            ))}
        </div>)
}